import { useQuery } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';
import { getAllFacilitiesApi } from './api';
import { sortByAlphabet } from '../../utils/sorting';
// TODO fix params
const useAllFacilities = ({ classification = null, params = null } = { classification: null, params: null }) => {
  const { enqueueSnackbar } = useSnackbar();

  const { data, isInitialLoading } = useQuery(
    ['allFacilities', params],
    () =>
      getAllFacilitiesApi({
        ...params,
        country: checkAccess([2]) ? getFranchiseRegion() : null,
      }),
    {
      onError: (error) => {
        enqueueSnackbar(error.message, { variant: 'error' });
      },

      select: ({ data }) => {
        if (classification) {
          return (
            data?.facilities
              .filter((item) => item.classification === classification)
              ?.sort((a, b) => sortByAlphabet(a.name, b.name)) || []
          );
        }

        return data?.facilities?.sort((a, b) => sortByAlphabet(a.name, b.name)) || [];
      },
    }
  );

  return {
    allFacilitiesNames: data?.map((item) => item.name) || [],
    allFacilities: data || [],
    isLoading: isInitialLoading,
  };
};

export default useAllFacilities;
